var render = function render(){var _vm=this,_c=_vm._self._c;return _c('awards-list',{staticClass:"gl-mt-5 gl-px-2",attrs:{"awards":_vm.awards,"can-award-emoji":_vm.canAwardEmoji,"current-user-id":_vm.currentUserId},on:{"award":function($event){return _vm.$emit('award', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }